import { render, staticRenderFns } from "./Hexagonia.vue?vue&type=template&id=4aa9cb18"
import script from "./Hexagonia.vue?vue&type=script&lang=js"
export * from "./Hexagonia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports